import React from "react"
import Styles from "../SharedComponents"
// import Links from "../Links"
import { useStaticQuery, graphql } from "gatsby"
import { Row } from "styled-grid-system-component"

import styled from "styled-components"

const Link = styled.a`
  text-decoration: underline;
`

const Skills = () => {
  const data = useStaticQuery(
    graphql`
      query {
        additionalData: dataJson {
          additional {
            skills
            expertise
            interests
            additional
          }
        }
        certificatesData: dataJson {
          certificates {
            img
            link
            title
          }
        }
      }
    `
  )

  const {
    additionalData: { additional: skills },
    certificatesData: { certificates },
  } = data

  const titleMap = {
    skills: "Languages & skills",
    expertise: "Key expertise",
    interests: "Research Interests",
    additional: "Additional Info",
  }

  return (
    <Row>
      {Object.keys(skills).map((key, i) => (
        <Styles.ColMargined md={6} sm={12} key={`skill_col_${i}`}>
          <Styles.Header>{titleMap[key]}</Styles.Header>
          <Styles.List>
            {skills[key].map((item, idx) => (
              <Styles.ListItem key={`skill_item_${i}_${idx}`}>
                {item}
              </Styles.ListItem>
            ))}
          </Styles.List>
        </Styles.ColMargined>
      ))}
      <Styles.ColMargined md={6} sm={12}>
        <Styles.Header>Certificates</Styles.Header>
        <Styles.List>
          {certificates.map(({ title, link }, idx) => (
            <Styles.ListItem key={`cert_item_${idx}`}>
              <Link href={link} target="_blank">
                {title}
              </Link>
            </Styles.ListItem>
          ))}
        </Styles.List>
      </Styles.ColMargined>
      {/* <Links /> */}
    </Row>
  )
}

export default Skills
